import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { PageTitle } from "../../../_metronic/layout/core";
import { getEwayBillDetail } from "../generic/crud";
import { showToast, TOAST_FAILURE } from "../../utils/toast/Toast";
import { EwayBillPrintSheet } from "./EwayBillPrintSheet";

/**
 * Printable NIC-format e-Way bill for a sale, fetched live from the server
 * (the bill and its payload snapshot live there). Needs the server reachable.
 */
export function EwayBillPrintPage() {
    const { saleId } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [ewayBill, setEwayBill] = useState(null);

    const breadcrumbs = [
        { title: "Home", path: "/dashboard", isSeparator: false, isActive: false },
        { title: "", path: "", isSeparator: true, isActive: false },
        { title: "Sales List", path: "/sales-list", isSeparator: false, isActive: false },
        { title: "", path: "", isSeparator: true, isActive: false },
    ];

    useEffect(() => {
        if (!saleId) return;
        setIsLoading(true);
        getEwayBillDetail(saleId)
            .then(({ data }) => {
                // A bill NIC issued alongside an IRN has no e-Way bill document of its own —
                // the e-Invoice sheet is that bill (it prints as "e-Invoice cum e-Way Bill").
                // Send the operator there rather than reporting the bill as missing.
                if (data?.exists && data.fromEInvoice) {
                    navigate(`/einvoice-print/${saleId}`, { replace: true });
                    return;
                }
                setEwayBill(data?.exists ? data.ewayBill : null);
                if (!data?.exists) {
                    showToast(data?.error || "No e-Way bill found for this sale", TOAST_FAILURE);
                }
                setIsLoading(false);
            })
            .catch(() => {
                showToast("Could not load the e-Way bill from the server", TOAST_FAILURE);
                setIsLoading(false);
            });
    }, [saleId]);

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>E-Way Bill</PageTitle>

            <div className="d-flex justify-content-end gap-2 mb-4 d-print-none">
                <Button variant="light" size="sm" onClick={() => navigate("/sales-list")}>
                    <i className="bi bi-arrow-left me-2"></i>Back to Sales
                </Button>
                {ewayBill && (
                    <Button variant="primary" size="sm" onClick={() => window.print()}>
                        <i className="bi bi-printer me-2"></i>Print
                    </Button>
                )}
            </div>

            {isLoading ? (
                <div className="text-center py-10">
                    <Spinner animation="border" className="text-primary" />
                    <div className="text-muted small mt-3">Fetching the e-Way bill from the server…</div>
                </div>
            ) : ewayBill ? (
                <EwayBillPrintSheet ewayBill={ewayBill} />
            ) : (
                <div className="text-center py-10 text-muted">
                    No e-Way bill found for this sale.
                </div>
            )}
        </>
    );
}
